export enum OrderErrorType {
  ShopInactiveError = 'ShopInactiveError',
  SalePeriodError = 'SalePeriodError',
  PickupPointInvalidError = 'PickupPointInvalidError',
  PickupTimeInvalidError = 'PickupTimeInvalidError',
  PaymentMethodError = 'PaymentMethodError',
  BasketEmptyError = 'BasketEmptyError',
  TotalMinimalAmountError = 'TotalMinimalAmountError',
  ServiceDateDeadlineError = 'ServiceDateDeadlineError',
  PickupFullError = 'PickupFullError',
  ProductUnknownError = 'ProductUnknownError',
  ProductStockUnknownError = 'ProductStockUnknownError',
  StockInsufficientError = 'StockInsufficientError',
  OrderHashAlreadyExistsError = 'OrderHashAlreadyExistsError',
  StockOverflowError = 'StockOverflowError',
  SellingModeNotRespectedError = 'SellingModeNotRespectedError',
  BasketValidationError = 'BasketValidationError',
  WrongPaymentMethodError = 'WrongPaymentMethodError',
  OverCoreMenuLimitError = 'OverCoreMenuLimitError',
  OverAmountLimitError = 'OverAmountLimitError',
  ProductNotInShopCatalogError = 'ProductNotInShopCatalogError',
  FormulaRequiredError = 'FormulaRequiredError',
  FormulaOnlyError = 'FormulaOnlyError',
  NegatifPriceError = 'NegatifPriceError',
}

interface ErrorMessageMapping {
  [key: string]: string;
}

export const errorMessages: ErrorMessageMapping = {
  [OrderErrorType.StockOverflowError]: 'errors.generic',
  [OrderErrorType.WrongPaymentMethodError]: 'errors.paymentMethodInvalid',
  [OrderErrorType.OverCoreMenuLimitError]: 'errors.maxCoreMenuExceeded',
  [OrderErrorType.OverAmountLimitError]: 'errors.priceExceedsLimit',
  [OrderErrorType.ProductNotInShopCatalogError]: 'errors.productUnknown',
  [OrderErrorType.FormulaRequiredError]: 'errors.formulaRequired',
  [OrderErrorType.FormulaOnlyError]: 'errors.formulaOnlyAllowed',
  [OrderErrorType.NegatifPriceError]: 'errors.negativeTotal',
  [OrderErrorType.ShopInactiveError]: 'errors.shopInactive',
  [OrderErrorType.SalePeriodError]: 'errors.salePeriod',
  [OrderErrorType.PickupPointInvalidError]: 'errors.pickupPointInvalid',
  [OrderErrorType.PickupTimeInvalidError]: 'errors.pickupTimeInvalid',
  [OrderErrorType.PaymentMethodError]: 'errors.paymentMethod',
  [OrderErrorType.BasketValidationError]: 'errors.basketValidationError',
  [OrderErrorType.SellingModeNotRespectedError]:
    'errors.sellingModeNotRespectedError',
  [OrderErrorType.BasketEmptyError]: 'errors.basketEmpty',
  [OrderErrorType.TotalMinimalAmountError]: 'errors.minimumOrderAmount',
  [OrderErrorType.ServiceDateDeadlineError]: 'errors.deadlinePassed',
  [OrderErrorType.PickupFullError]: 'errors.pickupFull',
  [OrderErrorType.ProductUnknownError]: 'errors.productUnknown',
  [OrderErrorType.ProductStockUnknownError]: 'errors.productStockUnknown',
  [OrderErrorType.StockInsufficientError]: 'errors.insufficientStock',
  [OrderErrorType.OrderHashAlreadyExistsError]: 'errors.orderHashAlreadyExists',
};

export interface ProductsFormattedFromError {
  productId: string;
  quantityLeft: number;
}

export interface ErrorContext {
  productLabels?: string[];
  productFormattedFromError?: ProductsFormattedFromError[];
  maxItems?: number;
  amountMax?: number;
  amountMin?: number;
}
